import BaseClass from 'components/BaseClass';
import Interstice from 'components/Interstice/Interstice';
import Preview from 'components/Preview';
import ReCaptcha from 'components/ReCaptcha/ReCaptcha';
import WelcomePopup from 'components/WelcomePopup';
import PageTemplateType from 'constants/PageTemplateType';
import React from 'react';
import { wrapComponent } from 'utils/framework';
import ChatEntry from 'components/Content/CustomerService/ChatWithUs/ChatEntry';
import SidModalDropdown from 'components/PersonalizedPreviewPlacements/SidModalDropdown';
import withSuspenseLoadHoc from 'utils/framework/hocs/withSuspenseLoadHoc';
import { CHAT_ENTRY } from 'constants/chat';

const SuperChat = withSuspenseLoadHoc(React.lazy(() => import(/* webpackChunkName: "postload" */ 'ai/components/SuperChat')));

const MinimizedSuperChat = withSuspenseLoadHoc(React.lazy(() => import(/* webpackChunkName: "postload" */ 'ai/components/MinimizedSuperChat')));
class GlobalContent extends BaseClass {
    constructor(props) {
        super(props);
        this.state = {
            isClient: false
        };
    }

    componentDidMount() {
        // Set isClient to true after mounting on the client side
        // This prevents Suspense from being used during SSR
        this.setState({ isClient: true });
    }

    render() {
        const { template } = this.props;
        const shouldSeePreview = template !== PageTemplateType.PreviewSettings;
        const { isGenAIChatEnabledUFE } = Sephora.configurationSettings;
        const { isClient } = this.state;

        return (
            <React.Fragment>
                <ReCaptcha />

                <Interstice />

                <WelcomePopup />

                {isClient && isGenAIChatEnabledUFE && (
                    <>
                        <SuperChat />
                        <MinimizedSuperChat />
                    </>
                )}

                <ChatEntry type={CHAT_ENTRY.global} />

                {!!shouldSeePreview && <SidModalDropdown />}

                {!!shouldSeePreview && <Preview />}
            </React.Fragment>
        );
    }
}

export default wrapComponent(GlobalContent, 'GlobalContent');
